import { useQuery } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import type { QueueStatsResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Live facility queue signal (GET /queue/stats?facility_id). Used to overlay
 * the real wait/queue-length on an ACTIVE drop-in window.
 *
 * `enabled` is the gate: pass it `false` for an upcoming (not-yet-open) window
 * so its stats are never even requested. That keeps the REALISM rule honest —
 * live wait/queue only shows while the window is active — at the network layer,
 * not just visually.
 */
export function useQueueStats(facilityId: string, enabled: boolean) {
  return useQuery<QueueStatsResponse>({
    queryKey: queryKeys.dropin.queueStats(facilityId),
    queryFn: () => queueApi.getStats(facilityId),
    enabled: enabled && Boolean(facilityId),
  });
}
